import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserAuth } from './AuthContext';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from './firebase'; // Make sure this import points to your Firebase config file

const Signin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [resetSent, setResetSent] = useState(false);
  const navigate = useNavigate();
  const { signIn } = UserAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('')
    try {
      await signIn(email, password);
      navigate('/home');
    } catch (e) {
      setError('Incorrect email or password');
      console.log(e.message);
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    if (!email) {
      setError('Please enter your email address to reset your password.');
      return;
    }
    try {
      await sendPasswordResetEmail(auth, email);
      setResetSent(true);
      setError('');
    } catch (e) {
      setError('Failed to send reset email. Please check your email address.');
      console.log(e.message);
    }
  };

  return (
    <div className='max-w-[700px] mx-auto my-16 p-4'>
      <div className="flex items-center justify-center mb-8">
        <img
          src="/logo.jpeg"
          alt="Teddy's Ladder logo"
          className="w-64 h-64 object-contain"
        />
      </div>
      {error && <p className='text-red-600 mb-4'>{error}</p>}
      {resetSent && <p className='text-green-600 mb-4'>Password reset email sent. Please check your inbox.</p>}
      <form onSubmit={handleSubmit}>
        <div className='flex flex-col py-2'>
          <label className='py-2 font-medium'>Email Address</label>
          <input 
            onChange={(e) => setEmail(e.target.value)} 
            className='border p-3' 
            type='email' 
          />
        </div>
        <div className='flex flex-col py-2'>
          <label className='py-2 font-medium'>Password</label>
          <input 
            onChange={(e) => setPassword(e.target.value)} 
            className='border p-3' 
            type='password' 
          />
        </div>
        <button className='border border-blue-500 bg-blue-600 hover:bg-blue-500 w-full p-4 my-2 text-white'>
          Sign In
        </button>
      </form>
      <div className='text-center mt-4'>
        <button 
          onClick={handleResetPassword}
          className='text-blue-500 hover:text-blue-600'
        >
          Forgot Password? Reset it here
        </button>
      </div>
    </div>
  );
};

export default Signin;
